import Vue from 'vue'

export default {
  getUserEvents (pageNumber, perPage, eventStatus) {
    var params = `page=${pageNumber}&per_page=${perPage}&status=${eventStatus}`
    return Vue.prototype.$http.get(`/events?${params}`)
  },

  getEvent (eventId) {
    return Vue.prototype.$http.get(`/events/${eventId}`)
  },

  updateEvent (eventId, formData) {
    return Vue.prototype.$http.put(`/events/${eventId}`, formData)
  },

  createEvent (formData) {
    return Vue.prototype.$http.post('/events', formData)
  },

  deleteEvent (eventId) {
    return Vue.prototype.$http.delete(`events/${eventId}`)
  }
}
